type RenameClick = Pick<MouseEvent, 'detail' | 'ctrlKey' | 'metaKey' | 'shiftKey' | 'altKey' | 'defaultPrevented'>;

// Modified clicks belong to structure selection; only a plain click may rename a selected row.
export const isComposerInlineRenameClick = (event: RenameClick) =>
    !event.defaultPrevented && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.detail <= 1;
